import i18next from 'i18next';

export const localizePrice = (price: number): string => {
    // Intl.NumberFormat è per correggere la virgola decimale in base alla lingua
    return Intl.NumberFormat(i18next.language, { maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(price);
};
